export const formatDueDate = (
  dateString: string | null | undefined
): string => {
  if (!dateString) return 'N/A';

  const fixedDate = dateString.replace(/\.(-|\+)/, '$1');

  // Parse the date and use UTC components to avoid timezone conversion
  const date = new Date(fixedDate);

  // Get UTC date components to avoid timezone shifts
  const month = date.getUTCMonth() + 1;
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();

  return `${month}/${day}/${year}`;
};

export const isOverdue = (dateString: string | null | undefined): boolean => {
  if (!dateString) return false;

  // Fix the API's malformed timezone format: remove dot before timezone
  const fixedDate = dateString.replace(/\.(-|\+)/, '$1');

  const dueDate = new Date(fixedDate);
  const today = new Date();

  // Compare at UTC midnight to avoid timezone issues
  const dueDateUTC = new Date(
    Date.UTC(
      dueDate.getUTCFullYear(),
      dueDate.getUTCMonth(),
      dueDate.getUTCDate()
    )
  );
  const todayUTC = new Date(
    Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())
  );

  return dueDateUTC < todayUTC;
};
